export default function getEmptyUserRequestSetupData(testStudioIds, testType = null) {

    let generalInfo = {};
    let specificInfo = {};

    generalInfo.testStudioIds = testStudioIds;
    generalInfo.testType = testType;
    generalInfo.quotationDeadline = undefined;

    specificInfo.testDetails = {};
    specificInfo.sampleSize = {
        items: {},
        optionInfos: {}
    };
    specificInfo.targetGroup = {};
    specificInfo.whatElse = {};
    specificInfo.isiServices = {
        services: [],
        servicesSelf: [],
        optionalServices: [],
    };
    specificInfo.timing = {};

    return { generalInfo, specificInfo };
}